var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField, useFormikContext } from "formik";
import React from "react";
export var FormItemTextarea = function (_a) {
    var name = _a.name, label = _a.label, tooltip = _a.tooltip, _b = _a.squareButtons, squareButtons = _b === void 0 ? 0 : _b, rest = __rest(_a, ["name", "label", "tooltip", "squareButtons"]);
    var setFieldValue = useFormikContext().setFieldValue;
    var _c = __read(useField(name), 2), field = _c[0], meta = _c[1];
    var touched = meta.touched, error = meta.error;
    var value = field.value;
    var errorText = touched && error ? error : null;
    var uuid = Math.random().toString(36).substring(7);
    var handleChange = function (e) {
        setFieldValue(name, e.currentTarget.value);
    };
    var addSquare = function (num, _a) {
        var uuid = _a.uuid;
        return function (e) {
            e.preventDefault();
            var textarea = document.getElementById(uuid);
            if (!textarea) {
                return;
            }
            // if (textarea !== document.activeElement){
            //   console.log('textarea is focused');
            //   textarea.focus();
            //   textarea.selectionStart = textarea.value.length;
            //   textarea.selectionEnd = textarea.value.length;
            // }
            var currentText = textarea.value;
            var pointerPositionStart = textarea.selectionStart;
            var pointerPositionEnd = textarea.selectionEnd;
            switch (num) {
                case -2:
                    textarea.value = currentText.substring(0, pointerPositionStart) + String.fromCharCode(8322) + currentText.substring(pointerPositionEnd);
                    break;
                case 3:
                    textarea.value = currentText.substring(0, pointerPositionStart) + String.fromCharCode(179) + currentText.substring(pointerPositionEnd);
                    break;
                case 2:
                default:
                    textarea.value = currentText.substring(0, pointerPositionStart) + String.fromCharCode(178) + currentText.substring(pointerPositionEnd);
            }
            setFieldValue(name, textarea.value);
            textarea.focus();
            textarea.selectionStart = pointerPositionStart + 1;
            textarea.selectionEnd = pointerPositionStart + 1;
        };
    };
    return (React.createElement("div", { className: "form-item-textarea" },
        React.createElement("div", { className: "form-item-textarea__label_row" },
            React.createElement("div", { className: "form-item-textarea__label_box" },
                React.createElement("label", { className: "form-item-textarea__label" }, label),
                tooltip ? (React.createElement("div", { className: "form-item-textarea__tooltip" },
                    "i",
                    React.createElement("div", { className: "form-item-textarea__tooltip_window" }, tooltip))) : (React.createElement(React.Fragment, null))),
            squareButtons ? (React.createElement("div", { className: "form-item-textarea__label_box" },
                React.createElement("button", { className: "form-item-textarea__button", onClick: addSquare(2, { uuid: uuid }) }, "x\u00B2"),
                React.createElement("button", { className: "form-item-textarea__button", onClick: addSquare(3, { uuid: uuid }) }, "x\u00B3"),
                React.createElement("button", { className: "form-item-textarea__button", onClick: addSquare(-2, { uuid: uuid }) }, "x\u2082"))) : (React.createElement(React.Fragment, null))),
        React.createElement("textarea", __assign({ className: "form-item-textarea__control", value: value, id: uuid, onChange: handleChange }, rest)),
        errorText && (React.createElement("div", { className: "form-item-textarea__error scroll_to_error" }, errorText))));
};
